import factory1 from "@/assets/animations/factory1.json";
import runningCorgi from "@/assets/animations/runningCorgi.json";
import jumpingFish from '@/assets/animations/jumpingFish.json'

export default {
  namespaced: true,
  name: "eastereggs",
  state: {
    isAnimating: false,
    animationData: factory1,
    runningCorgiAnimation: runningCorgi,
    jumpingFishAnimation: jumpingFish,
    isAnimatingCorgi: false,
    isAnimatingFish: false,
  },
  getters: {
    isAnimatingCorgi(state) {
      return state.isAnimatingCorgi;
    },
    runningCorgiAnimation(state) {
      return state.runningCorgiAnimation;
    },
    isAnimatingFish(state) {
      return state.isAnimatingFish;
    },
    isAnimating(state) {
      return state.isAnimating;
    },
    animationData(state) {
      return state.animationData;
    },
    jumpingFishAnimationData(state) {
      return state.jumpingFishAnimation;
    },
  },
  mutations: {
    setIsAnimating(state, flag) {
      state.isAnimating = flag;
    },
    setIsAnimatingFish(state, flag) {
      state.isAnimatingFish = flag;
    },
    setAnimationData(state, data) {
      state.animationData = data;
    },
    setAnimatingCorgi(state, flag) {
      state.isAnimatingCorgi = flag;
    },
  },
  actions: {
    animateCorgi({ commit }) {
      commit("setAnimatingCorgi", false);
      commit("setAnimatingCorgi", true);
      setTimeout(() => {
        commit("setAnimatingCorgi", false);
      }, 4500);
    },
    animateFish({ commit }) {
      commit("setIsAnimatingFish", false);
      commit("setIsAnimatingFish", true);
      setTimeout(() => {
        commit("setIsAnimatingFish", false);
      }, 4500);
    },
    completeFishAnimation({ commit }) {
      commit("setIsAnimatingFish", false);
    },
    completeCorgiAnimation({ commit }) {
      commit("setAnimatingCorgi", false);
    },
    startAnimating({ commit, state }) {
      const isAnimating = state.isAnimating;
      if (!isAnimating) {
        commit("setAnimationData", factory1);
        commit("setIsAnimating", true);
      } else {
        commit("setIsAnimating", false);
      }
    },
    completeAnimating({ commit }) {
      setTimeout(() => {
        commit("setIsAnimating", false);
      }, 750);
    },
  },
};
